<template>
  <div id="app">
    <top-menu v-if="$route.meta.headMenu"/>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <footer-vue v-if="$route.meta.headMenu"/>
  </div>
</template>
<script>
import topMenu from "@/components/topMenu.vue";
import footerVue from "@/components/footerVue.vue";

export default {
  components: {topMenu, footerVue},
}
</script>
<style lang="scss">
body{
  //background: #060818;
}
</style>
